async function upsellAdditional(cart = {}, variantsJson = [], t = '', $ = '') {
  if (cart?.items?.length > 0 && variantsJson?.length > 0 && t && $) {
    const cartItems = cart.items.filter(item => item.product_type !== "HSSLIDE_HIDDEN_PRODUCT");
    const cartItemIds = cartItems.map(item => item.id);

    const variantsUpsell = window.HSSLIDECART.variantsUpsell.json;


    const orderedVariants = cartItemIds.flatMap(cartItemId =>
      variantsUpsell
        .filter(variant => +variant.variant_id_father == +cartItemId &&
          !cartItemIds.includes(+variant.variant_id_child))
        .map(variant => ({
          //id: variant.product_id,
          handle: variant.variant_handle_child,
          variant_id: [variant.variant_id_child],
          //variant_id_father: variant.variant_id_father
        }))
    );

  
    let mergedVariants = Object.values(orderedVariants.reduce((acc, { handle, variant_id }) => {
      if (!acc[handle]) {
        acc[handle] = { handle, variant_id };
      } else {
        acc[handle].variant_id.push(...variant_id);
      }
      return acc;
    }, {})).filter(variant => variant.variant_id.length > 0 && variant.handle !== '');
    mergedVariants = moveHandleToFirst(mergedVariants, "orthopedic-bed-foundation") || mergedVariants;

    var count = 0, count_errors = 0, content_items = '';
    if (mergedVariants.length == 0) {
      !!document.querySelector('.hs-site-cart-popup .hs-frequently-bought.hs-swiper-title') ? document.querySelector('.hs-frequently-bought.hs-swiper-title').remove() : '';
      !!document.querySelector('.hs-site-cart-popup .hs-container-swp.hs-upsell-additional') ? document.querySelector('.hs-site-cart-popup .hs-container-swp.hs-upsell-additional').remove() : '';
      !!document.querySelector('.hs-site-cart-popup .hs-container-stacked.hs-swiper-content-upsell') ? document.querySelector('.hs-site-cart-popup .hs-container-stacked.hs-swiper-content-upsell').remove() : '';
    };
    for (let i = 0; i < mergedVariants.length; i++) {
      let element = mergedVariants[i];
      if(element.handle !== ''){
        await $.getJSON(window.Shopify.routes.root + `products/${element.handle}.js`, function (product) {
        if (product) {
          if (product.error) {
            return false;
          };
          const filteredVariants = product.variants.filter(variant => element.variant_id.includes('' + variant.id));
          product.variants = filteredVariants;
          if (product.variants.length == 0) {
            return false
          }
          let i = "", r = "", n = "", s = "";
          let l = product.variants[0].price || 0,
            c = product.variants[0].compare_at_price || 0;
          //arr_prods.push(product)
          $.each(product.variants, function (t, e) {
            r = r.concat(
              `<option value='${e.id}' title='${e.title}'
                          data-id='${product.id}' data-price=${e.price}
                          data-sku='${e.sku}' data-available='${e.available}'
                          data-barcode='${e.barcode} data-featuredimage='${product.featured_image}'
                          data-inventorymanagement='${e.inventory_management}' data-compareatprice='${e.compare_at_price}'
                          data-variantid='${e.id}'>
                          ${e.title}
                          </option>`
            );
          });
          if (product.variants.length == 1) {
            if (product.variants[0].title === 'Default Title') {
              n = " hs-hidden-element";
            };
          };

          (i = '<select class="hs-swipper-option-parent-' + product.id + " hs-swipper-select-option-add-to-cart" + n + '" data-id="' + product.id + '">' + r + "</select>");
          c > l ? ((c = HsCartDrawer.vat(c, t, $)), (c = '<div class="hs-compare-price-sw">' + (c = hsonslidecart.Currency.formatMoney(c, t.money_format)) + "</div>")) : (c = "");
          (l = HsCartDrawer.vat(l, t, $));
          (l = '<div class="hs-price-sw">' + hsonslidecart.Currency.formatMoney(l, t.money_format) + "</div>");
          (content_items = content_items.concat(
            '<div class="swiper-slide"><div class="hs-content-product-slide-cart"><div class="hs-product-content-image-swipper"><a href="javascript:void(0);" class="hs-product-link-image"><img src="' +
            HsCartDrawer.resizeSrc(product.featured_image, "x65") +
            '" /></a></div><div class="hs-content-title-price-swiper"><div class="hs-title-swiper">' +
            product.title +
            '</div><div class="hs-content-price-swiper">' +
            c +
            l +
            '</div><div class="hs-variants-swipper' +
            n +
            '">' +
            i +
            '</div><div class="hs-upsell-add"><button type="button" class="hs-upsell-add-to-cart"><span class="hs-add--to--cart">' +
            t.text_add +
            '</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw margin-bottom"></i></span></button></div></div></div></div>'
          ));
        };
      }).done(function () {
      }).fail(function () {
        count_errors++;
        count++;
        console.log("error");
      }).always(function () {
        count++;
        if (count == mergedVariants.length) {
          if (content_items !== '') {
            let mode_upsell = 0;
            if (mode_upsell || count == 1) {
              content_items = '<div class="hs-container-stacked hs-swiper-content-upsell"><div class="hs-frequently-bought"><h2>You Might Also Like These</h2></div><div class="hs-products-stacked">' + content_items + "</div></div>"
            } else {
              content_items = '<div class="hs-frequently-bought hs-swiper-title"><h2>You Might Also Like These</h2></div><div class="hs-container-swp hs-upsell-additional"><div class="swiper-container"><div class="swiper-wrapper hs-swiper-content-upsell">' +
                content_items +
                '</div><div class="swiper-pagination"></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>';
            };
            !!document.querySelector('.hs-site-cart-popup .hs-frequently-bought.hs-swiper-title') ? document.querySelector('.hs-frequently-bought.hs-swiper-title').remove() : '';
            !!document.querySelector('.hs-site-cart-popup .hs-container-swp.hs-upsell-additional') ? document.querySelector('.hs-site-cart-popup .hs-container-swp.hs-upsell-additional').remove() : '';
            !!document.querySelector('.hs-site-cart-popup .hs-container-stacked.hs-swiper-content-upsell') ? document.querySelector('.hs-site-cart-popup .hs-container-stacked.hs-swiper-content-upsell').remove() : '';

            !!document.querySelector('.hs-site-cart-popup .hs-dobly-content') ? document.querySelector('.hs-site-cart-popup .hs-dobly-content').insertAdjacentHTML("beforebegin", content_items) : '';

            if (!document.querySelector('#hs-personalize')) {
              let style = document.createElement('style');
              style.id = "hs-personalize";
              style.innerHTML = `
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-next, .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-prev{\
                              color: #000000 !important;\
                                  font-weight: bold !important;\
                                  position: absolute !important;\
                                  top: 50% !important;\
                                  width: calc(15px/ 15 * 27) !important;\
                                  height: 44px !important;\
                                  z-index: 10 !important;\
                                  cursor: pointer !important;\
                                  display: flex !important;\
                                  align-items: center !important;\
                                  justify-content: center !important;\
                                  line-height: 1 !important;\
                                  text-rendering: auto !important;\
                              }\
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-next, .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-container-rtl .swiper-button-prev {
                                  right: -25px;
                                  left: auto;
                              }
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-prev, .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-container-rtl .swiper-button-next {
                                  left: -25px;
                                  right: auto;
                              }
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-next:after, .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-prev:after{
                                  content: "";
                                  display: inline-block;
                                  margin: 0 5px;
                                  background: transparent;
                                  border-color: inherit !important;
                                  border-style: solid !important;
                                  
                                  height: 7px;
                                  margin-bottom: 0 !important;
                                  -webkit-transform: rotate(45deg);
                                  transform: rotate(45deg);
                                  width: 7px;
                              }
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-next:after{
                                  border-width: 2px 2px 0 0 !important;
                              }
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .swiper-button-prev:after{
                                  border-width: 0 0 2px 2px !important;
                              }
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .hs-upsell-add-to-cart.hs-loading-btn i.fa-circle-o-notch:before,
                              .hs-site-cart-popup .hs-container-stacked.hs-swiper-content-upsell .hs-upsell-add-to-cart.hs-loading-btn i.fa-circle-o-notch:before{\
                                  content: "\\f1ce";
                                  line-height: 35px;
                              }\
                              .hs-site-cart-popup .hs-container-stacked.hs-swiper-content-upsell .hs-upsell-add-to-cart.hs-loading-btn i.fa-spin,
                              .hs-site-cart-popup .hs-container-swp.hs-upsell-additional .hs-upsell-add-to-cart.hs-loading-btn i.fa-spin{
                                  -webkit-animation: fa-spin 0.8s linear infinite !important;
                                  animation: fa-spin 0.8s linear infinite !important;
                              }
                              @keyframes fa-spin {
                                  0% {
                                      transform: rotate(0deg);
                                  }
                                  100% {
                                      transform: rotate(360deg);
                                  }
                              }
                              `;
              document.head.appendChild(style);
            };
            swiperAdditional($, window.HsCartDrawer.json);
            upsellAdditionalVariants($, window.HsCartDrawer.json);

          };
        };
        if (count_errors == mergedVariants.length) {
          //thisAdd(where, qt, '');
        };
      });
      };
    }

  };

};

function upsellAdditionalVariants(e = '', t = '') {
  if (e && t) {
    e(".hs-swiper-content-upsell .hs-swipper-select-option-add-to-cart").unbind("change");
    e(".hs-swiper-content-upsell .hs-swipper-select-option-add-to-cart").change(function (a) {
      a.preventDefault();
      var i = hsonslidecart.Currency.formatMoney(e(this).find("option:selected").data("price"), t.money_format),
        r = hsonslidecart.Currency.formatMoney(e(this).find("option:selected").data("compareatprice"), t.money_format),
        n = e(this).find("option:selected").data("available");
      e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").removeAttr("disabled"),
        n
          ? (e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").find(".hs-add--to--cart").html(t.text_add),
            e(this).closest(".hs-content-title-price-swiper").find(".hs-price-sw").html(i),
            e(this).closest(".hs-content-title-price-swiper").find(".hs-compare-price-sw").html(r))
          : (e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").prop("disabled", !0),
            e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").find(".hs-add--to--cart").html(t.text_stock),
            e(this).closest(".hs-content-title-price-swiper").find(".hs-price-sw").html(i),
            e(this).closest(".hs-content-title-price-swiper").find(".hs-compare-price-sw").html(r));
    });
    if (!e(".hs-swiper-content-upsell .hs-upsell-add-to-cart").hasClass("hs-event-static")) {
      e(".hs-swiper-content-upsell .hs-upsell-add-to-cart").addClass('hs-event-static');
      e(".hs-swiper-content-upsell .hs-upsell-add-to-cart").unbind("click");
      e(".hs-swiper-content-upsell .hs-upsell-add-to-cart").click(function (a) {
        var i = e(this),
          r = e(this).closest(".hs-content-title-price-swiper").find(".hs-swipper-select-option-add-to-cart").val();
        i.addClass("hs-loading-btn"), (HsCartDrawer.params = { id: r, quantity: 1 }), HsCartDrawer.ajaxProductCartUpsell(HsCartDrawer.params, i, t, e);
      });
    };
  }
};

function swiperAdditional(e = '', t = '') {
  let mode_upsell = 0;
  if (!t || !e) return false;
  if (!parseInt(t.enable_slide_cart)) return false;
  if (parseInt(mode_upsell)) return false;
  var a = parseInt(t.count_slide_cart_products);
  a > 1 && (a = 1),
    new Swiper(".hs-container-swp.hs-upsell-additional .swiper-container", {
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      /* pagination: {
          el: ".swiper-pagination",
          clickable: true,
      }, */
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });



  /* e(".hs-container-swp.hs-upsell-additional .swiper-pagination-bullet").hover(function () {
      e(this).click();
  }); */
};

function moveHandleToFirst(arr, handleToMove) {
  const index = arr.findIndex(item => item.handle === handleToMove);
  if (index === -1) {
    return arr;
  };

  if (index > 0) {
    const [item] = arr.splice(index, 1);
    arr.unshift(item);
  };
  return arr;
};

var switcher_root = document.querySelectorAll('label.hs-sl-switch-root').length > 0 ? document.querySelectorAll('label.hs-sl-switch-root') : 0;  
if (!!switcher_root) {
  switcher_root.forEach(function (element) {
    if (!element.classList.contains('hs-sl-event-static')) {
      element.classList.add('hs-sl-event-static');
      element.addEventListener('click', function (event) {
        event.preventDefault();
        var content = document.querySelectorAll('.hs-sl-all-content-bundle-root').length > 0 ? document.querySelector('.hs-sl-all-content-bundle-root') : 0;
        var switch_content = document.querySelectorAll('.hs-sl-base-root').length > 0 ? document.querySelector('.hs-sl-base-root') : 0;
        var switch_element = document.querySelectorAll('.hs-sl-switch-thumb').length > 0 ? document.querySelector('.hs-sl-switch-thumb') : 0;
        var first_swtich_element = document.querySelectorAll('.hs-sl-check-svg').length > 0 ? document.querySelector('.hs-sl-check-svg') : 0;
        var elementText = document.querySelectorAll('.hs-sl-content-bundle-root').length > 0 ? document.querySelector('.hs-sl-content-bundle-root') : 0;
        var newElement = `<svg class="hs-sl-check-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#165570"></circle><mask id="mask0_29_2" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20"><rect width="20" height="20" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_29_2)"><path d="M7.97916 14.6459C7.86805 14.6459 7.76041 14.6251 7.65624 14.5834C7.55207 14.5417 7.45138 14.4723 7.35416 14.3751L3.83332 10.8542C3.66666 10.6876 3.58679 10.4758 3.59374 10.2188C3.60068 9.96189 3.68749 9.75008 3.85416 9.58342C4.02082 9.41675 4.22916 9.33341 4.47916 9.33341C4.72916 9.33341 4.93749 9.41675 5.10416 9.58342L8.02082 12.5001L14.9167 5.60425C15.0833 5.43758 15.2882 5.35425 15.5312 5.35425C15.7743 5.35425 15.9792 5.43758 16.1458 5.60425C16.3125 5.77091 16.3958 5.97578 16.3958 6.21883C16.3958 6.46189 16.3125 6.66675 16.1458 6.83341L8.60416 14.3751C8.50693 14.4723 8.40624 14.5417 8.30207 14.5834C8.19791 14.6251 8.09027 14.6459 7.97916 14.6459Z" fill="white"></path></g></svg>`;
        var firstElement = `<span class="hs-sl-switch-thumb hs-sl-switch-circle"></span>`;
        var elementTextOff = `<strong>Early Black Friday Sale Certified Organic Bedding Offer!</strong>`;
        var elementTextActive = `Added Bedding Offer!`;
        
        if (!content.classList.contains('hs-sl-active-element-switch')) {
          content.classList.add('hs-sl-active-element-switch');
          if(!!switch_element)
          {
            //console.log(content.querySelector('.hs-sl-mui-switch-input'));
            switch_element.remove();
            switch_content.insertAdjacentHTML('beforeend', newElement);
            elementText.innerHTML = elementTextActive;
            content.querySelector('.hs-sl-mui-switch-input').setAttribute("checked", "checked");
          }
        }else{
          content.classList.remove('hs-sl-active-element-switch');
          if(!!first_swtich_element)
          {
            //console.log(content.querySelector('.hs-sl-mui-switch-input'));
            first_swtich_element.remove();
            switch_content.insertAdjacentHTML('beforeend', firstElement);
            elementText.innerHTML = elementTextOff;
            content.querySelector('.hs-sl-mui-switch-input').removeAttribute("checked");
          }
        }
      });
    }
  });
}